import React, {
  useRef, Children, cloneElement, useMemo
} from 'react';
import { nanoid } from 'nanoid';
import './index.css';

type CustomMachRefreshProps = React.PropsWithChildren<{
  loading: boolean; // 是否正在加载
  hasMore: boolean; // 是否有更多数据
  noMoreTip?: string; // 没有更多数据的提示文案
  pullDownEnable?: boolean; // 是否开启下拉刷新
  pullUpEnable?: boolean; // 是否开启上拉加载
  pullUpPullingText?: string; // 上拉加载上拉时的文案
  pullUpLoadingText?: string; // 上拉加载加载中的文案
  onPullDown?: () => void; // 触发下拉刷新
  onPullUp?: () => void; // 触发上拉加载
}>;

export default function CustomMachRefresh(props: CustomMachRefreshProps) {
  const {
    children,
    pullUpEnable = true,
    pullDownEnable = true,
    loading = false,
    hasMore = false,
    pullUpLoadingText,
    pullUpPullingText,
    noMoreTip,
    onPullDown,
    onPullUp,
  } = props;

  // 增强子组件
  const enhancedChildren = Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return cloneElement(child, {
        key: nanoid(10),
        // 合并原有 props
        ...child.props,
        // 注入属性
        enableRefreshControl: true,
        pullUpLoadingText,
        pullUpPullingText,
        loading,
        hasMore,
        noMoreTip,
        onPullUp: pullUpEnable ? onPullUp : undefined,
        onPullDown: pullDownEnable ? onPullDown : undefined,
      });
    }
    return child;
  });

  return <> {enhancedChildren}</>;
}
